import { defineMessages } from 'react-intl-next';
export var asyncPopupSelectMessages = defineMessages({
  projectLabel: {
    id: 'linkDataSource.basic-filter.project.label',
    description: 'Label to be displayed for project filter dropdown button.',
    defaultMessage: 'Project'
  },
  statusLabel: {
    id: 'linkDataSource.basic-filter.status.label',
    description: 'Label to be displayed for status filter dropdown button.',
    defaultMessage: 'Status'
  },
  typeLabel: {
    id: 'linkDataSource.basic-filter.type.label',
    description: 'Label to be displayed for type filter dropdown button.',
    defaultMessage: 'Work type'
  },
  typeLabelOld: {
    id: 'linkDataSource.basic-filter.type.labelOld',
    description: 'Label to be displayed for type filter dropdown button.',
    defaultMessage: 'Type'
  },
  assigneeLabel: {
    id: 'linkDataSource.basic-filter.assignee.label',
    description: 'Label to be displayed for assignee filter dropdown button.',
    defaultMessage: 'Assignee'
  },
  projectSearchPlaceholder: {
    id: 'linkDataSource.basic-filter.project.searchPlaceholder',
    description: 'Placeholder to be displayed for project filter dropdown search input.',
    defaultMessage: 'Search for projects'
  },
  statusSearchPlaceholder: {
    id: 'linkDataSource.basic-filter.status.searchPlaceholder',
    description: 'Placeholder to be displayed for status filter dropdown search input.',
    defaultMessage: 'Search for status'
  },
  typeSearchPlaceholder: {
    id: 'linkDataSource.basic-filter.type.searchPlaceholder',
    description: 'Placeholder to be displayed for work type filter dropdown search input.',
    defaultMessage: 'Search for work type'
  },
  assigneeSearchPlaceholder: {
    id: 'linkDataSource.basic-filter.assignee.searchPlaceholder',
    description: 'Placeholder to be displayed for assignee filter dropdown search input.',
    defaultMessage: 'Search for assignee'
  }
});